let suppressDepth = 0;
/** True while undo/redo restore (including async mesh rebuild) is in flight. */
let restoreInProgress = false;
/** False until project content has finished loading — blocks undo of initial load. */
let historyReady = false;
/** Bumps whenever history is wiped so stale debounced commits are ignored. */
let historySessionId = 0;

export function suppressGridHistory() {
  suppressDepth += 1;
  return () => {
    suppressDepth = Math.max(0, suppressDepth - 1);
  };
}

export function isGridHistoryRestoreInProgress() {
  return restoreInProgress;
}

export function isGridHistorySuppressed() {
  return suppressDepth > 0 || restoreInProgress;
}

export function beginGridHistoryRestore() {
  restoreInProgress = true;
  return suppressGridHistory();
}

export function endGridHistoryRestore(releaseSuppress) {
  restoreInProgress = false;
  if (typeof releaseSuppress === 'function') {
    releaseSuppress();
  }
}

export function setGridHistoryReady(ready) {
  historyReady = !!ready;
}

export function isGridHistoryReady() {
  return historyReady;
}

export function bumpGridHistorySession() {
  historySessionId += 1;
  return historySessionId;
}

export function getGridHistorySessionId() {
  return historySessionId;
}
